export default {_name:'radio.group',module:'Field',view:'Element/Field/Group/Radio',options:{events:{onChange:'persistChange'},helperText:' '}}